import React, { FC } from "react";
import { Snackbar, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ViewsMenuSettingsStyles } from "./viewsMenuSettingsStyles";

interface SuccessMessageProps {
  open: boolean;
  message: string;
  onClose: () => void;
  autoHideDuration?: number;
}

const SuccessMessage: FC<SuccessMessageProps> = ({
  open,
  message,
  onClose,
  autoHideDuration = 4000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={ViewsMenuSettingsStyles.snackbar}
    >
      <Alert
        onClose={onClose}
        severity="success"
        variant="filled"
        icon={<CheckCircleIcon />}
        sx={ViewsMenuSettingsStyles.successAlert}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SuccessMessage;
